import { FieldProps } from "@rjsf/utils";
import TextInput from "../../Inputs/Text";
import { Input } from "../__styles__/Inputs";

export const UniqueIdInput = (props: FieldProps) => {
  const value = props.formData;
  const disabled = props.disabled || props.readonly;

  return (
    <Input
      id={props.idSchema.$id}
      isSubmissionBuilder={props.isSubmissionBuilder}
    >
      <TextInput
        name={props.name}
        label={props.schema.title}
        required={props.required && !disabled}
        placeholder={props.uiSchema?.["ui:placeholder"]}
        value={value}
        onChange={props.onChange}
        disabled={false}
        readonly={true}
        helperText={props.uiSchema?.["ui:helperText"]}
        tooltip={props.uiSchema?.["ui:tooltipText"]}
        error={props.rawErrors?.join(", ")}
        labelSize={props.uiSchema?.["ui:labelSize"]}
      />
    </Input>
  );
};
